import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Dropdown, Menu, Modal } from 'antd'
import { ItemDeleteText } from 'components/ActionStyles/ActionStyles'
import VerticalThreeDots from 'components/icons/VerticalThreeDots'
import { SmallButtons } from 'modules/Courses/Style/style'
import React from 'react'
import styled from 'styled-components'
import { EmptyDivElement } from '../../../../components/UIComponents/CommonStyledComponent'

const { confirm, warning } = Modal

const CustomMenu = styled(Menu)`
  width: 150px;
`
const ActionMenu = ({
  item,
  editClicked,
  deletedClicked,
  editCourse,
  setStatusIsActive,
  courseID,
  isStudentLinked,
  cruds,
}) => {
  const onDelete = id => {
    deletedClicked(id)
  }
  const showConfirm = id => {
    !isStudentLinked
      ? confirm({
          title: 'Do you want to delete this course',
          icon: <ExclamationCircleOutlined />,
          onOk() {
            onDelete(id)
          },
          onCancel() {},
          okText: 'Delete',
        })
      : warning({
          title:
            'This course cannot be deleted as there are previous transactions associated',
          icon: <ExclamationCircleOutlined />,
          onOk() {},

          okText: 'Ok',
        })
  }
  let menuItems = [
    {
      key: '1',
      hidden: !cruds?.includes('EDIT'),
      label: <EmptyDivElement onClick={editClicked}>View & Edit </EmptyDivElement>,
    },
    {
      key: '2',
      hidden: !cruds?.includes('ACTIVE/INACTIVE'),

      label: (
        <EmptyDivElement onClick={setStatusIsActive}>
          {' '}
          {item?.status === 0 ? 'Set as Active' : 'Set as Inactive'}
        </EmptyDivElement>
      ),
    },
    {
      key: '3',
      hidden: !cruds?.includes('DELETE'),

      label: <ItemDeleteText>Delete </ItemDeleteText>,
      onClick: () => showConfirm(courseID),
    },
  ]?.filter(item => !item?.hidden)
  const menu = <CustomMenu items={menuItems} />
  return (
    <div id="filterDropdown">
      <Dropdown
        onClick={event => editCourse(event, item)}
        overlay={menu}
        trigger={['click']}
        getPopupContainer={() => document.getElementById('filterDropdown')}
      >
        <SmallButtons height={'38px'} icon={<VerticalThreeDots />} />
      </Dropdown>
    </div>
  )
}
export default ActionMenu
